import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { message, PageHeader } from 'antd';
import {
  rackRegistryGetByIdService,
  rackRegistryUpdateService,
} from 'services/rackregistry';
import NetworkToolWrapper from '../../layouts/NetworkToolWrapper';
import { MyBreadcrumb } from 'utils';
import RackRegistryForm from './form';

const RackRegistryUpdate = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await rackRegistryGetByIdService(id);
      if (response.data.items && response.data.items.length > 0) {
        setData(response.data.items[0]);
      }
    } catch (error) {
      message.error('Failed to fetch rack registry data');
      history.push('/rackregistry');
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    try {
      await rackRegistryUpdateService(id, values);
      message.success('Rack registry updated successfully');
      history.push('/rackregistry');
    } catch (error) {
      message.error('Failed to update rack registry');
    }
  };

  return (
    <NetworkToolWrapper isBranchClientRequired={false}>
      <MyBreadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Networking Dashboard', path: '/network-dashboard' },
          { label: 'Rack Registry', path: '/rackregistry' },
          { label: 'Update Rack Registry', path: '' },
        ]}
      />
      <PageHeader
        ghost={false}
        onBack={() => history.push('/rackregistry')}
        title="Update Rack Registry"
        subTitle=""
      >
        <RackRegistryForm
          onFinish={onFinish}
          initialValues={data}
          loading={loading}
        />
      </PageHeader>
    </NetworkToolWrapper>
  );
};

export default RackRegistryUpdate;
